import React, { useState }                                  from 'react'
import Box                                                  from '@material-ui/core/Box'
import ClassNoteShowComponent                               from './ClassNoteShowComponent'
import Grid                                                 from '@material-ui/core/Grid'
import PropTypes                                            from 'prop-types'
import Typography                                           from '@material-ui/core/Typography'

const ClassNoteComponent = ( props ) => {

   const { classNote } =  props

   const { note, tpsClass } = classNote

   const [ noteIndex,         setNoteIndex      ]  =  useState(0)
   const [ showTitles,        setShowTitles     ]  =  useState(true)
console.log('note.length is', note.length)
   const handleSelectNote = (i) => {
      console.log('You clicked note', i)
      setNoteIndex(i)
      setShowTitles(false)
   }

   const collapseNote = () => {
      setShowTitles(true)
   }

   const showNoteTitles = note.map( (n,i) => {
      return (
         <Grid key={i} >
            <Typography variant='h5' align='left' onClick={() => handleSelectNote(i)} >
               {n.noteTitle} (Click to expand)
            </Typography>
         </Grid>
      )
   })

   return (
      <Box>
         {note.length > 1 && showTitles
            ?
               <Grid>
                  <Typography variant='h5' align='left' style={{ marginBottom: '0.5rem' }} >
                     Notes for TPS Class: {tpsClass}
                  </Typography>
                  { showNoteTitles }
               </Grid>
            :
               <ClassNoteShowComponent collapseNote={collapseNote} note={note[noteIndex]} numNotes={note.length} />
         }
      </Box>
)
}

ClassNoteComponent.propTypes = {
    classNote: PropTypes.object
}

export default ClassNoteComponent